export const filterTypes = {
    checkbox: 'checkbox',
};
const filterGroups = [
    {
        id: 'equipment',
        title: 'Equipment',
        localizationSlug: 'EQUIPMENT',
        type: 'equipment',
    },
    {
        id: 'shipper',
        title: 'Shipper',
        localizationSlug: 'SHIPPER',
        type: 'shippers',
    },
    {
        id: 'carrier',
        title: 'Carrier',
        localizationSlug: 'CARRIER',
        type: 'carriers',
    },
    {
        id: 'outstanding_balance',
        title: 'Outstanding AR/AP',
        localizationSlug: 'OUTSTANDING_AR_AP',
        type: 'checkbox',
        filters: ['outstanding_ar', 'outstanding_ap'],
    },
    {
        id: 'insufficient_documentation',
        title: 'Missing Documentation',
        localizationSlug: 'MISSING_DOCUMENTATION',
        type: 'checkbox',
        filters: ['Yes', 'No'],
    },
    {
        id: 'email_sent',
        title: 'Invoice Sent',
        localizationSlug: 'INVOICE_SENT',
        type: 'checkbox',
        filters: ['Yes', 'No'],
    },
    {
        id: 'status',
        title: 'Status',
        localizationSlug: 'STATUS',
        type: 'checkbox',
        filters: [
            'created',
            'en_route',
            'arrived',
            'booking',
            'booked',
            'complete',
            'canceled',
        ],
    },
    {
        id: 'order_type',
        title: 'Order Type',
        localizationSlug: 'ORDER_TYPE',
        type: 'dropdown',
        filters: [
            {
                localizationSlug: 'IMPORT',
                name: 'import',
                value: 'import',
            },
            {
                localizationSlug: 'EXPORT',
                name: 'export',
                value: 'export',
            },
        ],
    },
    {
        id: 'estimated_arrival',
        title: 'Estimated Arrival',
        localizationSlug: 'ESTIMATED_ARRIVAL',
        type: 'date',
    },
    {
        id: 'arrival_date',
        title: 'Arrival Date',
        localizationSlug: 'ARRIVAL_DATE',
        type: 'date',
    },
    {
        id: 'last_free_day',
        title: 'Last Free Day',
        localizationSlug: 'LAST_FREE_DAY',
        type: 'date',
    },
    {
        id: 'service_type',
        title: 'Service Type',
        localizationSlug: 'SERVICE_TYPE',
        type: 'dropdown',
        filters: [
            {
                localizationSlug: 'LIVE_LOAD_UNLOAD',
                name: 'Live Load/Unload',
                value: 'live',
            },
            {
                localizationSlug: 'DROP_HOOK',
                name: 'Drop & Hook',
                value: 'drop',
            },
        ],
    },
    {
        id: 'vessel_or_rail',
        title: 'Vessel/Train',
        localizationSlug: 'VESSEL_TRAIN',
        type: 'text',
    },
    /** TODO: CARGO-9224 - Enhance Functionality of steamship_or_railroad
     * Current Implementation: A free text input is being used with functionality not working since we now use OCEAN SCAC code
     * Improvement: Transform this filter into a SCAC CODE based drop down
     * */
    // {
    //   id: 'steamship_or_railroad',
    //   title: 'Steamship/Railroad',
    //   localizationSlug: 'STEAMSHIP_RAILROAD',
    //   type: 'text',
    // },
    /** TODO: CARGO-9224 - Enhance Functionality of Location Filter
     * Current Implementation: A free text input is being used with functionality not working.
     * Improvement: Transform this filter into a location-based
     * */
    // {
    //   id: 'arriving',
    //   title: 'Arriving',
    //   localizationSlug: 'ARRIVING',
    //   type: 'text',
    // },
    // {
    //   id: 'delivering',
    //   title: 'Delivering',
    //   localizationSlug: 'DELIVERING',
    //   type: 'text',
    // },
];
export default filterGroups;
